import { render, staticRenderFns } from "./u-tab-button.vue?vue&type=template&id=6755df2a&scoped=true&"
import script from "./u-tab-button.vue?vue&type=script&lang=js&"
export * from "./u-tab-button.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-button.vue?vue&type=style&index=0&id=6755df2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755df2a",
  null
  
)

export default component.exports